/**
 * Qué departamento manda en la lista de puestos del alta de solicitud, y qué
 * decir cuando no hay nada que elegir.
 *
 * Un puesto solo se puede pedir del departamento de la solicitud. Quien puede
 * crear solicitudes de cualquier área elige el departamento en el formulario;
 * el resto crea siempre en el suyo, y el servidor lo toma de su token.
 */

export interface EntradaDeDepartamento {
  /** El selector de departamento está a la vista. */
  selectorVisible: boolean
  /** Lo que se eligió en el selector (llega como texto del select). */
  areaElegida?: string | number | null
  /** El departamento del usuario, el de su cuenta. */
  areaPropia?: number | null
}

/** El departamento de la solicitud, o undefined si todavía no hay uno. */
export const departamentoDeLaSolicitud = ({
  selectorVisible,
  areaElegida,
  areaPropia,
}: EntradaDeDepartamento): number | undefined => {
  if (selectorVisible) {
    const elegida = Number(areaElegida)
    return Number.isInteger(elegida) && elegida > 0 ? elegida : undefined
  }
  return areaPropia ? areaPropia : undefined
}

export type AvisoDePuestos = 'sin_departamento' | 'elige_departamento' | 'sin_puestos'

export const avisoDePuestos = ({
  departamento,
  selectorVisible,
  cargando,
  cantidad,
}: {
  departamento?: number
  selectorVisible: boolean
  cargando: boolean
  cantidad: number
}): AvisoDePuestos | null => {
  if (!departamento) return selectorVisible ? 'elige_departamento' : 'sin_departamento'
  if (!cargando && cantidad === 0) return 'sin_puestos'
  return null
}

export const textoDelAviso = (
  aviso: AvisoDePuestos,
  selectorVisible: boolean,
): string => {
  switch (aviso) {
    case 'sin_departamento':
      return 'Tu usuario no tiene un Departamento/Área asignada. Contacta al administrador.'
    case 'elige_departamento':
      return 'Elige primero el departamento para ver sus puestos.'
    case 'sin_puestos':
      return selectorVisible
        ? 'Este departamento no tiene puestos creados. Contacta al administrador.'
        : 'Tu departamento no tiene puestos creados. Contacta al administrador.'
  }
}
